import React, { Component } from "react"
import { UploadProgress, UploadProgressStore } from "@albelli/image-list-view-upload-progress"
import { locale } from "@albelli/photoselector"

interface Props {
  uploadProgress: UploadProgress
  uploadStore: UploadProgressStore
  maxFileSize: string
}

export default class UploadError extends Component<Props, any> {
  constructor(props: Props) {
    super(props)

    this.state = {
      items: this.props.uploadStore.getFileList(),
      showErrorList: false,
      showErrorSummary: true
    }
    this.receiveError = this.receiveError.bind(this)
  }

  receiveError() {
    this.setState({ items: this.props.uploadStore.getFileList() })
  }

  componentDidMount() {
    this.props.uploadProgress.subscribe("error", this.receiveError)
  }

  componentWillUnmount() {
    this.props.uploadProgress.unsubscribe("error", this.receiveError)
  }

  mapErrorCodeToMessage(code: string) {
    const uploadErrors = locale.get().upload.errors
    switch (code) {
      case "MAX_FILE_SIZE":
        return uploadErrors[code].replace("{0}", this.props.maxFileSize)
      default:
        return uploadErrors.hasOwnProperty(code) ? uploadErrors[code] : uploadErrors["GENERIC_ERROR"]
    }
  }

  getErrorList() {
    const filesInErrorState = this.state.items.filter((item) => item.hasOwnProperty("state") && item.state === "error")

    return filesInErrorState.map((item) => ({
      id: item.regId != null ? item.regId : item.localId,
      fileName: item.error.file.name,
      message: this.mapErrorCodeToMessage(item.error.error.code)
    }))
  }

  render() {
    const errorList = this.getErrorList()

    if (errorList.length > 0) {
      return (
        <div>
          <div
            className="photoselector-mydevice-uploaderrors"
            onClick={() => this.setState({ showErrorList: true })}
            style={{ display: this.state.showErrorList || !this.state.showErrorSummary ? "none" : "block" }}
          >
            <div
              className="photoselector-mydevice-uploaderror-close"
              onClick={(e: React.SyntheticEvent) => {
                e.stopPropagation()
                this.setState({ showErrorSummary: false })
              }}
            >
              X
            </div>
            {locale.get().upload.errorSummary(errorList.length)}
          </div>
          <div className="photoselector-mydevice-uploaderror-dialog" style={{ display: this.state.showErrorList ? "block" : "none" }}>
            <div
              className="photoselector-mydevice-uploaderror-dialog-close"
              onClick={(e: React.SyntheticEvent) => {
                e.stopPropagation()
                this.setState({ showErrorList: false })
              }}
            >
              X
            </div>
            <h3>{locale.get().upload.errorDialog.headline}</h3>
            <p>{locale.get().upload.errorDialog.ingress}</p>
            <div style={{ height: "200px", overflow: "auto" }}>
              <table>
                <thead>
                  <tr>
                    <th>{locale.get().upload.errorDialog.filenameColumn}</th>
                    <th>{locale.get().upload.errorDialog.reasonColumn}</th>
                  </tr>
                </thead>
                <tbody>
                  {errorList.map((error) => (
                    <tr key={error.id}>
                      <td>{error.fileName}</td>
                      <td>{error.message}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}
